/*
 * Copyright (c) 2022-2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import { getCurrentDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'
import dayjs from 'dayjs'
import { collectionGroup, query, where } from 'firebase/firestore'
import { FireBaseStore } from '@/model/firebase/google-fire-base'
import { resultOfId } from '@/model/firebase/queryUtils'

const entity = {
  couponCode: {
    displayName: 'RedeemCode',
    formConfig: {
      disableEdit: true
    }
  },
  couponDiscountStr: {
    displayName: 'discountType'
  },
  maxDiscountAmount: {
    displayName: 'MaxDiscountValue'
  },
  effectiveAbove: {
    displayName: 'MinEffectiveAmount'
  },
  maxClaimCount: {
    displayName: 'MaxClaimCount'
  },
  startTime: {
    type: IKDataEntity.Types.Date,
    displayName: 'startTime'
  },
  endTime: {
    type: IKDataEntity.Types.Date,
    displayName: 'endTime'
  },
  isActive: {
    type: IKDataEntity.Types.Boolean,
    formConfig: {
      default: true
    }
  },
  allowMultipleClaim: {
    displayName: 'multiSelect',
    type: IKDataEntity.Types.Boolean,
    formConfig: {
      default: true
    }
  }
}
const config = {
  load: async function () {
    const res = query(collectionGroup(FireBaseStore,
      'coupon-main-by-coupon-code'),
    where('deviceId', '==', await getCurrentDeviceId()))
    const allList = (await resultOfId(res))
    allList.forEach(it => {
      it.startTime = dayjs.unix(it.startTimestamp.seconds).format('YYYY-MM-DD')
      it.endTime = dayjs.unix(it.endTimestamp.seconds).format('YYYY-MM-DD')
    })
    return allList
  },
  add: async function (item) {
    item.deviceId = await getCurrentDeviceId()
    item.startTimestamp = dayjs(item.startTime).utc().format()
    item.endTimestamp = dayjs(item.endTime).utc().format()
    return await hillo.jsonPost('https://createcoupon-evhwqutgjq-ey.a.run.app', {
      ...item
    })
  },
  edit: async function (item) {
    item.deviceId = await getCurrentDeviceId()
    item.startTimestamp = dayjs(item.startTime).utc().format()
    item.endTimestamp = dayjs(item.endTime).utc().format()
    return await hillo.jsonPost('https://updatecoupon-evhwqutgjq-ey.a.run.app', {
      ...item
    })
  },
  remove: async function (item) {
    return await hillo.jsonPost('https://deletecoupon-evhwqutgjq-ey.a.run.app', {
      deviceId: await getCurrentDeviceId(),
      couponCode: item
    })
  }
}

export default IKDataEntity.ModelFactory(entity, config)
